import { TableLoader } from "../../commons";
import FullScreenDialog from "../../commons/FullScreenDilog/FullScreenDilog";
import ViewPerformanceEvaluationDetails from "./ViewPerformanceEvaluationDetails";
type DropDownType ={
  value:string;
  label:string;
}
type AppProps = {
  success: number | null;
  isOpen: boolean;
  data: any;
  fetching: boolean;
  toggleSubmitManagerFeedback: (id?: string) => void;
  feedbackComment: string;
  handleCommentChange: (data: string) => void;
  performanceRating: DropDownType;
  handlePerformanceRatingChange: (data: DropDownType) => void;
  handleAddManagerFeedback: () => void;
  type?:string;
  uploadFiles:(data:any)=>void;
  files:any;
  uploadFetching:boolean;
  handleDeleteUploadedFile:(data:number)=>void;
};

const ManagerViewPEFormModal = ({
  isOpen,
  data,
  success,
  fetching,
  toggleSubmitManagerFeedback,
  feedbackComment,
  handleCommentChange,
  performanceRating,
  handlePerformanceRatingChange,
  handleAddManagerFeedback,
  type,
  uploadFiles,
  files,
  uploadFetching,
  handleDeleteUploadedFile
}: AppProps) => {
  const jobBody = () => {
    return (
      <>
      {!fetching ? 
        <ViewPerformanceEvaluationDetails    
        
          data={data}
          feedbackComment={feedbackComment}
          handleCommentChange={handleCommentChange}
          performanceRating={performanceRating}
          handlePerformanceRatingChange={handlePerformanceRatingChange}
          type={type}
          uploadFiles={uploadFiles}
          files={files}
          uploadFetching={uploadFetching}
          handleDeleteUploadedFile={handleDeleteUploadedFile}
        />
      :<TableLoader Rows={10} ColumnPerRow={5} />}
      </>
    );
  };

  return (
    <div>
      <FullScreenDialog
        success={success}
        onClose={toggleSubmitManagerFeedback}
        showSchedulingEstimateData={data}
        title={"Submit PE Feedback Form"}
        body={jobBody}
        saveBtn={"Save Changes"}
        onSubmit={handleAddManagerFeedback}
        disabled={data?.feedback?.length || type=="MYPE" || (feedbackComment?.length===0 || !performanceRating?.value)}
      />
    </div>
  );
};

export default ManagerViewPEFormModal;
